/**
 * Smart Fog Drawing Generator - Main App
 */

import { SchematicEditor } from './features/schematic-editor/SchematicEditor';
import './styles/index.css';

export function App() {
  return (
    <div className="app">
      <SchematicEditor />
    </div>
  );
}
